module.exports = __webpack_public_path__ + "img/vin_image3.9cf1ed80.jpg";